/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable react/jsx-fragments */
/* eslint-disable react/jsx-wrap-multilines */
import React from "react";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Chip from "@material-ui/core/Chip";
import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import Autocomplete from "@material-ui/lab/Autocomplete";

const useStyles = makeStyles(() => ({
  labelRoot: {
    color: "#333333BF",
    fontSize: 16,
    marginLeft: 4,
  },
  labelShrink: {
    color: "#333",
    fontFamily: "'Open Sans', sans-serif",
    fontWeight: 600,
    fontSize: 12,
  },
  fieldHelperText: {
    fontFamily: "'Open Sans', sans-serif",
    fontSize: 14,
    color: "#999",
  },
  field: {
    width: 480,
    fontFamily: "'Open Sans', sans-serif",
    fontSize: 14,
  },
  chipRoot: {
    fontFamily: "'Open Sans', sans-serif",
    fontSize: 16,
    lineHeight: "24px",
    padding: "14px 4px",
    "&:hover": {
      borderColor: "#26BBED",
    },
  },
  chipErrorRoot: {
    fontSize: 16,
    lineHeight: "24px",
    padding: "14px 4px",
    borderColor: "#E75F5F !important",
  },
  chipIcon: {
    color: "#333",
    "&:hover": {
      color: "#E75F5F",
    },
  },
  outlinedChip: {
    border: "1px solid #333",
    color: "#333",
    margin: 5,
  },
  hideClearIcon: {
    display: "none",
  },
  duplicatedChip: {
    fontSize: 16,
    lineHeight: "24px",
    padding: "14px 4px",
    border: "1px solid #26bbed",
    background: "#26bbed1a",
    transition: "all 0.5s",
  },
  inputField: {
    padding: "8px 4px",
    fontSize: 16,
    width: "auto",
  },
  inputBase: {
    flexWrap: "wrap",
  },
}));

const Chips = ({
  propValues = ["dy@hy.ly"],
  label = "",
  onChangeCallback = () => {},
  helperText = "Please hit enter or comma to add values",
  validator = () => true,
  placeholder = "",
  ...rest
}) => {
  const classes = useStyles();
  const [inputValue, setInputValue] = React.useState("");
  const [values, setValues] = React.useState([]);
  const [duplicatedIndex, setDuplicatedIndex] = React.useState(null);

  const handleInput = (event) => {
    if (event.code === "Comma" || event.code === "Enter") {
      if (event.target.value && event.target.value !== "") {
        if (!values.includes(event.target.value.replace(",", ""))) {
          setValues([...values, event.target.value.replace(",", "")]);
          onChangeCallback([...values, event.target.value.replace(",", "")]);
        } else {
          setDuplicatedIndex(values.indexOf(event.target.value.replace(",", "")));
        }
        setInputValue("");
      }
    }
  };

  const handleDelete = (value) => {
    setValues(values.filter((item) => item !== value));
    onChangeCallback(values.filter((item) => item !== value));
  };

  const handleChipClick = (option) => {
    let options = values.filter((item) => item !== option);
    // Get rid of the selected value from values array
    setValues(options);
    // Set the value of input field with the selected on
    setInputValue(option);
    onChangeCallback(options);
  };

  React.useEffect(() => {
    setValues(propValues);
  }, [propValues]);

  return (
    <FormControlLabel
      control={
        <Autocomplete
          multiple
          options={[]}
          value={values}
          freeSolo
          classes={{
            tag: classes.outlinedChip,
            endAdornment: classes.hideClearIcon,
            inputRoot: classes.inputBase,
          }}
          renderTags={(value, getTagProps) =>
            value.map((option, index) => (
              <Chip
                className={classes.outlinedChip}
                variant="outlined"
                label={option}
                size="small"
                classes={{
                  root:
                    duplicatedIndex !== index
                      ? validator(option)
                        ? classes.chipRoot
                        : classes.chipErrorRoot
                      : classes.duplicatedChip,
                  deleteIcon: classes.chipIcon,
                }}
                deleteIcon={<CloseIcon onMouseUp={() => handleDelete(option)} />}
                onClick={() => handleChipClick(option)}
                {...getTagProps({ index })}
              />
            ))
          }
          renderInput={(params) => (
            <TextField
              helperText={helperText}
              {...params}
              variant="standard"
              classes={{
                root: classes.field,
              }}
              FormHelperTextProps={{
                classes: {
                  root: classes.fieldHelperText,
                },
              }}
              InputLabelProps={{
                classes: {
                  shrink: classes.labelShrink,
                  root: classes.labelRoot,
                },
              }}
              placeholder={placeholder}
              inputProps={{
                ...params.inputProps,
                value: inputValue,
                onChange: (e) => setInputValue(e.target.value),
                onKeyUp: handleInput,
                className: classes.inputField,
              }}
              label={label}
            />
          )}
        />
      }
      labelPlacement="start"
      {...rest}
    />
  );
};

export default Chips;
